/**
 * LedPanel (mobile) — espelho local do componente `apps/ia/src/components/LedPanel.tsx`.
 *
 * Esta cópia vive em `components/mobile/` para evitar imports cross-folder
 * confusos a partir da `MobileMicPage` e dos componentes irmãos do mic.
 * Comportamento, props e classes CSS são IDÊNTICOS ao original.
 *
 * 3 LEDs verticais com efeito Knight Rider bounce (1 → 2 → 3 → 2 → 1).
 * Os `@keyframes` (kr-green-1/2/3, kr-amber-*, kr-red-*) e as classes
 * `.led-col`, `.kr-green`, `.kr-amber`, `.kr-red`, `.kr-green-rec` já vivem
 * em `styles/global.css` GLOBAL — não precisa importar nada aqui.
 *
 * Variants:
 *   - 'off'        → 3 LEDs apagados (apenas borda esmaecida)
 *   - 'green'      → KR verde 1.8s suave (estado conectado / OK)
 *   - 'amber'      → KR amarelo 1.2s médio (conectando / processando)
 *   - 'red'        → KR vermelho 0.9s urgente (desconectado / erro)
 *   - 'green-rec'  → KR verde 0.6s rápido (gravando ativamente)
 *
 * Acessibilidade: o elemento é `aria-hidden` (puro feedback visual) e
 * respeita `prefers-reduced-motion` via @media query global.
 */
export type LedVariant = 'off' | 'green' | 'amber' | 'red' | 'green-rec';

interface LedPanelProps {
  readonly variant?: LedVariant;
}

const VARIANT_CLASS: Record<LedVariant, string> = {
  off: '',
  green: 'kr-green',
  amber: 'kr-amber',
  red: 'kr-red',
  'green-rec': 'kr-green-rec',
};

export function LedPanel({ variant = 'off' }: LedPanelProps) {
  const krClass = VARIANT_CLASS[variant];
  const className = krClass ? `led-col ${krClass}` : 'led-col';
  return (
    <span className={className} aria-hidden="true">
      <span className="led" />
      <span className="led" />
      <span className="led" />
    </span>
  );
}

export default LedPanel;
